import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
  sortCaret,
  headerSortingClasses,
} from "../../_metronic/_helpers";
import { useSubheader } from "../../_metronic/layout";
import { Link, useHistory } from "react-router-dom";
import { baseURLV1 } from "../service/API.js";
import axios from "axios";
import Pagination2 from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { Modal, Button, Form } from "react-bootstrap";

export const SendCoupon = () => {
  const suhbeader = useSubheader();
  const [event, setEvent] = useState([]);
  const [couponList, setCouponList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalSize, setTotalSize] = useState(100);
  suhbeader.setTitle("Send Coupon management");
  const { authToken } = useSelector((state) => state.auth);
  const history = useHistory();

  useEffect(() => {
    getData(1, 10, search);
  }, []);

  const getData = async (page, limit, search) => {
    setPage(page);
    axios({
      method: "get",
      url: `${baseURLV1}/coupon/list?page=${page}&limit=${limit}${search ? "&search=" + search : ""}`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    }).then((res) => {
      if (res.message) {
        history.push("/logout");
      }
      var totalpage = Math.ceil(res.data.total / res.data.limit);
      setTotalPage(totalpage);
      setTotalSize(res.data.total);
      setLimit(res.data.limit);
      setEvent(res.data.data);
      setCouponList(res.data.couponList);

    });
  };

  const convertDate = (date, formatDate) => {
    const dates = new Date(date)
    const result = dates.toLocaleDateString(formatDate, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
    return result
  }


  const columns = [
    {
      dataField: "uid",
      text: "Ref Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '100px' }}>
            <p>{row.uid}</p>
          </div>
        );
      },
    },
    {
      dataField: "mobile",
      text: "Mobile",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '100px' }}>
            <p>{row.mobile}</p>
          </div>
        );
      },
    },
    {
      dataField: "delivery_name",
      text: "Delivery Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
     
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "created_at",
      text: "Adjust Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '160px' }}>
            <p>{row.created_at ? convertDate(row.created_at, 'th-TH') : '-'}</p>
          </div>
        );
      },
    },
    {
      text: "Action",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '300px' }}>
            <button
              type="button"
              className="btn btn-primary m-1"
              onClick={() => resendSMS({ id, row, rowIndex })}
            >
              Re Send
            </button>

            <button
              type="button"
              className="btn btn-primary m-1"
              onClick={() => editItem({ id, row, rowIndex })}
            >
              Edit Mobile
            </button>

            <button
              type="button"
              className="btn btn-primary m-1"
              onClick={() => getLinkItem({ row, rowIndex })}
            >
              Get Link
            </button>

          </div>
        );
      },
    },
  ];

  const resendSMS = (data) => {
    Swal.fire({
      title: "ยืนยันกาทำรายการ?",
      text: "จะทำการส่ง sms ใหม่อีกครั้ง !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        axios.put(`${baseURLV1}/coupon/resendSMS/${data.row.id}`)
          .then((res) => {
            Swal.fire("แจ้งเตือน", "ทำรายการสำเร็จ!", "success");
          })
          .catch((err) => {
            Swal.fire(
              "แจ้งเตือน",
              "ทำรายการไม่สำเร็จ!",
              "error"
            );
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("แจ้งเตือน", "ยกเลิกการทำรายการ", "error");
      }
    })
  }

  const editItem = (data) => {
    Swal.fire({
      title: 'Mobile',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: "Cancel",
      showLoaderOnConfirm: true,
      preConfirm: (value) => {
        return axios.put(`${baseURLV1}/coupon/changeMobile/${data.row.id}`, { mobile: value })
          .then((res) => {
            return res
          })
          .catch((err) => {
            Swal.showValidationMessage(
              `Request failed: ${err}`
            )
          });
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then(async (result) => {
      if (result.isConfirmed) {
        await Swal.fire("แจ้งเตือน", "ทำรายการสำเร็จ!", "success");
        getData(page, limit, search);
      }
    })

  }

  const getLinkItem = (data) => {
    axios.get(`${baseURLV1}/coupon/link/${data.row.id}`)
      .then((res) => {
        navigator.clipboard.writeText(res.data.link)
        Swal.fire("ทำรายการสำเร็จ!", res.data.link, "success");
      })
      .catch((err) => {
        Swal.fire(
          "แจ้งเตือน",
          "ทำรายการไม่สำเร็จ!",
          "error"
        );
      });
  }

  const [search, setSearch] = useState();
  const handleSearch = () => {
    setPage(1);
    getData(1, limit, search);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getData(value, limit, search);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    getData(1, event.target.value, search);
  };

  return (
    <Card>
      <CardHeader title="List">
        <CardHeaderToolbar>
          <Link to="/ImportSendCoupon">
            <button type="button" className="btn btn-primary mr-2">
              + Import
            </button>
          </Link>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="row form-inline mb-2">
          <div className="col-lg-3 col-md-3 col-sm-3">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Text Search"
                style={{ width: "100%" }}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="mr-3">
            <div className="form-group">
              <button
                type="button"
                id="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
                onClick={() => handleSearch()}
              >
                Search
              </button>
            </div>
          </div>
        </div>


        <BootstrapTable
          keyField="id"
          data={event}
          columns={columns}
          // wrapperClasses="table-responsive table-cm"
          bordered={false}
          bootstrap4
          noDataIndication={"Table is Empty"}
        />
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <div className="mt-3">
                {"Items Per Page: "}
                <select onChange={handlePageSizeChange} value={limit}>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
            </div>
            <div className="col-lg-6">
              <Pagination2
                className="mt-3 "
                count={totalPage}
                page={page}
                siblingCount={1}
                boundaryCount={1}
                variant="outlined"
                shape="rounded"
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
